<template>
  <tr>
    <td class="px-1">
      <input
        type="number"
        class="input"
        @keydown.enter="focusRefs('formRinciPacking')"
        ref="formRinciKoli"
        @blur="updateData"
        v-model="formData.koli"
      />
    </td>
    <td class="px-1">
      <input
        type="text"
        class="input"
        @keydown.enter="focusRefs('formRinciP')"
        ref="formRinciPacking"
        @blur="updateData"
        v-model="formData.packing"
      />
    </td>
    <td class="px-1">
      <input
        type="number"
        class="input"
        @keydown.enter="focusRefs('formRinciL')"
        ref="formRinciP"
        @blur="updateData"
        v-model="formData.p"
      />
    </td>
    <td class="px-1">
      <input
        type="number"
        class="input"
        @keydown.enter="focusRefs('formRinciT')"
        ref="formRinciL"
        @blur="updateData"
        v-model="formData.l"
      />
    </td>
    <td class="px-1">
      <input
        type="number"
        class="input"
        @keydown.enter="focusRefs('formRinciKG')"
        ref="formRinciT"
        @blur="updateData"
        v-model="formData.t"
      />
    </td>
    <td class="px-1">
      <input
        type="number"
        class="input"
        @blur="updateData"
        v-model="calculateM3"
      />
    </td>
    <td class="px-1">
      <input
        type="number"
        class="input"
        @blur="updateData"
        v-model="formData.kg"
        ref="formRinciKG"
      />
    </td>
    <td class="px-1">
      <input type="number" class="input" v-model="calculateTon" />
    </td>
    <td class="px-1">
      <v-btn
        depressed
        color="error"
        @click="deleteData"
        :loading="loading"
        :disabled="loading"
        class="v-btn-small"
      >
        <v-icon>mdi-delete</v-icon>
      </v-btn>
    </td>
  </tr>
</template>

<script>
import axios from "axios";

export default {
  name: "FormDetil",
  props: ["nottb", "data"],
  data() {
    return {
      formData: {
        id: this.data.id,
        koli: this.data.koli,
        packing: this.data.packing,
        p: this.data.p,
        l: this.data.l,
        t: this.data.t,
        m3: this.data.m3,
        kg: this.data.kg,
        ton: this.data.ton
      },
      loading: false
    };
  },
  watch: {
    calculateTon(val) {
      this.formData.ton = val;
      this.updateData();
    }
  },
  computed: {
    calculateM3: {
      get: function() {
        return (
          Math.round(
            ((this.formData.p * this.formData.l * this.formData.t) / 1000000) *
              this.formData.koli *
              100
          ) / 100
        ).toFixed(2);
      },
      set: function(value) {
        this.formData.m3 = value;
      }
    },
    calculateTon: {
      get: function() {
        return ((this.formData.kg * this.formData.koli) / 1000).toFixed(2);
      },
      set: function(value) {
        this.formData.ton = value;
      }
    }
  },
  methods: {
    async deleteData() {
      this.loading = true;

      await axios
        .delete(`ttb-rinci/${this.data.id}`)
        .then(res => {
          this.loading = false;
          this.$emit("update-rinci");
        })
        .catch(err => {
          alert(err.response.data.message);
        });
    },
    async updateData() {
      if (Number(this.formData.koli || 0) <= 0) {
        return;
      }

      this.loading = true;

      await axios
        .put(`update-ttb-rinci/all`, this.formData)
        .then(res => {
          this.loading = false;
          this.$emit("update-rinci");
        })
        .catch(err => {
          this.loading = false;
          alert(err.response.data.message);
        });
    },
    focusRefs(id) {
      this.$refs[id].focus();
    }
  }
};
</script>

<style scoped>
.input {
  border: 1px solid lightgray;
  padding: 1px 4px;
  outline: none;
  width: 100%;
}

.v-btn-small {
  height: 25px !important;
}
</style>
